import { ButtonIconPermissioned } from "components/ButtonIconPermissioned/ButtonIconPermissioned";
import ModalCloneProject from "components/ModalProject/ModalCloneProject";
import { useModalContext } from "providers/ModalProvider/ModalProvider";

interface ButtonIconCloneProjectProps {
  projectId: string;
}

/**
 * Renders a permissioned button with a tooltip to copy a project.
 * Opens a modal to clone the project when clicked.
 * Consumes the {@link useModalContext} hook to manage modal state.
 */
export const ButtonIconCloneProject = ({
  projectId,
}: ButtonIconCloneProjectProps) => {
  const { openModal, closeModal } = useModalContext();
  return (
    <ButtonIconPermissioned
      requiredPermission="download"
      defaultTooltip="Copy project"
      iconType="copy"
      aria-label="Clone project"
      onClick={() => {
        openModal(
          <ModalCloneProject projectId={projectId} onClose={closeModal} />,
        );
      }}
      color="primary"
      data-test-subj="clone-project-button"
    />
  );
};
